import { render, staticRenderFns } from "./ContentImageLightbox.vue?vue&type=template&id=a871d63c&scoped=true&"
import script from "./ContentImageLightbox.vue?vue&type=script&lang=ts&"
export * from "./ContentImageLightbox.vue?vue&type=script&lang=ts&"
import style0 from "./ContentImageLightbox.vue?vue&type=style&index=0&id=a871d63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a871d63c",
  null
  
)

export default component.exports